var map = {
	"./1.webp": 5036,
	"./10.webp": 6972,
	"./11.webp": 1855,
	"./12.webp": 5214,
	"./13.webp": 1241,
	"./14.webp": 1088,
	"./15.webp": 6851,
	"./16.webp": 9202,
	"./17.webp": 3917,
	"./2.webp": 8073,
	"./3.webp": 6638,
	"./4.webp": 9699,
	"./5.webp": 9296,
	"./6.webp": 7613,
	"./7.webp": 2050,
	"./8.webp": 4951,
	"./9.webp": 1252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 795;